export interface Chapter {
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  chapterNumber: number;
  excerpt: string;
  content: string;
  wordCount: number;
  viewCount: number;
  publishDate: string;
  isNew: boolean;
  isHot: boolean;
}

export const chapters: Chapter[] = [
  {
    id: 'ch-1',
    title: '第一章：豪门婚礼',
    slug: 'chapter-1',
    categoryId: 'cat-1',
    categoryName: '初入豪门',
    chapterNumber: 1,
    excerpt: '婚礼的钟声在圣彼得大教堂响起，林婉儿穿着价值百万的定制婚纱，站在红毯的尽头。她的目光透过白纱，看向那个即将成为她丈夫的男人——沈墨辰。',
    content: '婚礼的钟声在圣彼得大教堂响起，林婉儿穿着价值百万的定制婚纱，站在红毯的尽头。她的目光透过白纱，看向那个即将成为她丈夫的男人——沈墨辰。\n\n他站在神父面前，西装笔挺，面容冷峻。那双深邃的眼眸中没有新婚的喜悦，只有一种让人捉摸不透的深沉。\n\n"婉儿，你确定要嫁给他吗？"伴娘苏晴在她耳边低语，语气中满是担忧。\n\n林婉儿微微一笑，握紧了手中的捧花。"当然。"\n\n她以为这是一场灰姑娘的童话，却不知道等待她的是一场精心策划的荒唐赌局。\n\n婚礼进行曲响起，她迈出脚步，走向那个未知的未来。教堂的彩绘玻璃将阳光切割成斑斓的光斑，洒在她的婚纱上，像是命运洒下的碎片。\n\n沈墨辰伸出手，他的掌心温热而干燥。当她的手指触碰到他的那一刻，一种奇异的感觉从指尖蔓延至全身。\n\n"从今天起，你就是沈太太了。"他的声音低沉而富有磁性，却听不出任何感情。\n\n林婉儿抬头看着他，努力让自己的笑容看起来自然："我会做好一个妻子的本分。"\n\n他的嘴角微微上扬，那抹笑意却未达眼底。"希望如此。"\n\n婚礼结束后的豪车中，沈墨辰递给她一份文件。\n\n"这是什么？"\n\n"婚前协议的补充条款，签了它。"\n\n林婉儿接过文件，翻开第一页，瞳孔骤然收缩。\n\n上面赫然写着——"婚姻存续期间，乙方需无条件配合甲方提出的任何合理要求。"\n\n"什么叫任何合理要求？"她的手微微发抖。\n\n沈墨辰侧过头，那双眼睛在昏暗中闪烁着危险的光芒。\n\n"别担心，只是一场游戏而已。你不会玩不起吧？"',
    wordCount: 3500,
    viewCount: 128500,
    publishDate: '2024-03-15',
    isNew: false,
    isHot: true,
  },
  {
    id: 'ch-2',
    title: '第二章：新婚之夜',
    slug: 'chapter-2',
    categoryId: 'cat-1',
    categoryName: '初入豪门',
    chapterNumber: 2,
    excerpt: '新婚之夜，沈墨辰却没有出现在婚房。林婉儿独自坐在铺满玫瑰花瓣的大床上，听着窗外海浪拍打礁石的声音，心中涌起一种不祥的预感。',
    content: '新婚之夜，沈墨辰却没有出现在婚房。\n\n林婉儿独自坐在铺满玫瑰花瓣的大床上，听着窗外海浪拍打礁石的声音，心中涌起一种不祥的预感。\n\n她起身走到落地窗前，拉开厚重的窗帘。月光洒在海面上，波光粼粼。这栋位于半山腰的别墅是沈家的产业之一，据说价值超过两亿。\n\n可此刻，这座金碧辉煌的宫殿却让她感到窒息。\n\n门外传来脚步声，林婉儿的心跳骤然加速。\n\n门被推开，走进来的却不是沈墨辰。\n\n"太太，先生让我转告您，他今晚有事不能回来了。"一个穿着黑色西装的管家模样的中年男人站在门口，面无表情地说道。\n\n"什么事？"林婉儿尽量让自己的声音听起来平静。\n\n"先生的事，我们不便过问。"管家微微欠身，"太太有什么需要，随时吩咐。"\n\n门重新合上。\n\n林婉儿坐在床边，看着满屋的红色装饰——红色的喜字，红色的床幔，红色的地毯。这一切本该是喜庆的象征，此刻却像是一场讽刺的闹剧。\n\n她拿起手机，想给母亲打电话，手指停在屏幕上却迟迟没有拨出去。母亲为了她的婚事操碎了心，她不能让母亲担心。\n\n手机屏幕亮起，是一条陌生号码发来的短信。\n\n"新婚快乐。游戏才刚刚开始，希望你能玩到最后。"\n\n林婉儿的手猛地一抖，手机掉在了地毯上。\n\n她弯腰去捡，却看到了床底下露出一角的东西——一个相框。\n\n她将相框拉出来，翻过来一看，整个人僵在了原地。\n\n照片上，沈墨辰搂着一个女人，两人笑得无比亲密。而那个女人——\n\n和她长得一模一样。',
    wordCount: 3200,
    viewCount: 116800,
    publishDate: '2024-03-16',
    isNew: false,
    isHot: true,
  },
  {
    id: 'ch-3',
    title: '第三章：沈家的秘密',
    slug: 'chapter-3',
    categoryId: 'cat-1',
    categoryName: '初入豪门',
    chapterNumber: 3,
    excerpt: '第二天清晨，林婉儿在别墅中闲逛时，无意间发现了一间上锁的房间。好奇心驱使她推开了那扇门，却看到了让她毛骨悚然的东西。',
    content: '第二天清晨，阳光透过落地窗洒进房间。林婉儿一夜未眠，眼眶下是淡淡的青色。\n\n她换上简单的家居服，决定在这座巨大的别墅中四处走走。\n\n别墅一共有三层，一楼是客厅、餐厅和厨房，二楼是主卧和客房，三楼据管家说是一些储藏室。\n\n林婉儿沿着楼梯走上三楼，走廊两侧是几扇紧闭的房门。她随意地推开其中一扇，里面堆满了落灰的家具和杂物。\n\n就在她准备转身离开时，走廊尽头的一扇门引起了她的注意。\n\n那扇门与其他的门不同——它是一扇厚重的铁门，上面挂着一把崭新的密码锁。\n\n为什么储藏室要用密码锁？\n\n好奇心像一只猫爪，在她心头挠着。她走近那扇门，发现密码锁旁边的墙壁上有一小块污渍——看起来像是干涸的血迹。\n\n她的心跳开始加速。\n\n就在这时，背后传来一个冰冷的声音："太太，这里不是您该来的地方。"\n\n林婉儿猛地转身，看到管家站在走廊的另一端，脸上依旧是那副波澜不惊的表情。\n\n"我只是随便看看。"她努力让自己的声音听起来自然。\n\n"三楼正在翻修，灰尘大，太太还是请回吧。"管家做了个请的手势，态度恭敬却不容拒绝。\n\n林婉儿点点头，快步走下楼梯。但她的脑海中一直萦绕着那个问题——\n\n那扇铁门后面，到底藏着什么？',
    wordCount: 2800,
    viewCount: 105200,
    publishDate: '2024-03-17',
    isNew: false,
    isHot: true,
  },
  {
    id: 'ch-10',
    title: '第十章：荒唐的赌约',
    slug: 'chapter-10',
    categoryId: 'cat-2',
    categoryName: '荒唐赌约',
    chapterNumber: 10,
    excerpt: '沈墨辰终于揭开了赌约的真相。林婉儿的世界在一瞬间崩塌——她的婚姻，她的人生，从一开始就是一场游戏。',
    content: '沈墨辰的书房很大，四面墙都是直达天花板的书架，上面摆满了精装书籍。空气中弥漫着雪茄和威士忌混合的气味。\n\n"坐。"沈墨辰指了指书桌对面的椅子。\n\n林婉儿坐下，努力让自己看起来镇定。\n\n沈墨辰从抽屉里拿出一份文件，推到林婉儿面前。\n\n"这是什么？"\n\n"你一直想知道的答案。"\n\n林婉儿打开文件，第一页上的内容让她的血液瞬间凝固了。\n\n那是一份赌约协议，签署方是沈墨辰和另外三个人——沈墨辰的两个弟弟和一个她从未听说过的名字。\n\n协议的内容很简单：四个人各选一个女人作为"赌注"，在六个月的时间内，看谁能最先让目标女人彻底沦陷。赌金——五千万。\n\n而林婉儿的名字，赫然写在沈墨辰那一栏。\n\n"你疯了吗？"林婉儿的声音在发抖。\n\n沈墨辰靠在椅背上，点燃了一支雪茄。烟雾缭绕中，他的面容变得模糊不清。\n\n"从一开始，你就是我的目标。你父亲的债务，你母亲的医药费，你弟弟的学费——这一切都是我安排的。"他的声音平静得像在讲述今天的天气。"我需要一个完美的赌注，而你，刚好符合所有条件。"\n\n林婉儿感到一阵天旋地转。她想起父亲突然还清的赌债，想起母亲被转进最好的医院，想起弟弟顺利进入重点大学——所有这些她以为是命运眷顾的事，原来都是他的布局。\n\n"为什么？"她的声音嘶哑。\n\n"为什么？"沈墨辰笑了笑，"因为无聊。有钱人的生活比你想象的无聊得多。我们需要一些刺激——一些真正的游戏。"',
    wordCount: 4500,
    viewCount: 195000,
    publishDate: '2024-04-10',
    isNew: false,
    isHot: true,
  },
  {
    id: 'ch-15',
    title: '第十五章：欲望深渊',
    slug: 'chapter-15',
    categoryId: 'cat-3',
    categoryName: '情欲迷局',
    chapterNumber: 15,
    excerpt: '明知这是一场赌局，林婉儿却发现自己正在一步一步地沦陷。沈墨辰的每一个眼神，每一次触碰，都像毒药一样渗入她的骨髓。',
    content: '明知这是一场赌局，林婉儿却发现自己正在一步一步地沦陷。\n\n那天晚上，沈墨辰破天荒地在家吃晚饭。餐桌上摆满了精致的菜肴，烛光摇曳，气氛暧昧得让人心跳加速。\n\n"你今天很美。"他举起酒杯，目光灼灼地看着她。\n\n林婉儿低下头，心跳如擂鼓。她知道自己应该恨他，可当他的目光落在她身上时，那种从心底涌起的感觉却不受控制。\n\n"别忘了，你只是一个赌注。"她在心里反复提醒自己。\n\n可当沈墨辰起身走到她身边，俯身在她耳边低语时，所有的理智都化为了灰烬。\n\n"我知道你在想什么。"他的声音低沉而温柔，"你在想，这一切是不是真的。让我告诉你——它比你想象的更加真实。"\n\n他的手抚上她的脸颊，那触感像是电流，从皮肤表层直接传导到心脏。\n\n"可你只是在利用我。"林婉儿的声音在颤抖。\n\n"是吗？"沈墨辰的嘴角微微上扬，"那你现在推开我。"\n\n林婉儿伸出手，想要推开他，却发现自己做不到。她的手停在他的胸口，能感受到他强劲有力的心跳。\n\n"你看，你不想推开我。"他的声音带着一种蛊惑的魔力。\n\n那一夜，林婉儿第一次没有抗拒。她沉溺在他营造的欲望深渊中，明知这是陷阱，却心甘情愿地跳了下去。\n\n第二天清晨，当她醒来时，沈墨辰已经不在身边。床头柜上放着一张字条，上面只有一行字——\n\n"游戏还在继续，你做得很好。"\n\n林婉儿将字条揉成一团，却发现自己的嘴角竟然微微上扬。\n\n她已经分不清，这究竟是恨，还是别的什么。',
    wordCount: 3800,
    viewCount: 176000,
    publishDate: '2024-04-25',
    isNew: false,
    isHot: true,
  },
  {
    id: 'ch-20',
    title: '第二十章：他的真心',
    slug: 'chapter-20',
    categoryId: 'cat-3',
    categoryName: '情欲迷局',
    chapterNumber: 20,
    excerpt: '一次意外让林婉儿看到了沈墨辰不为人知的一面。那个冷酷无情的男人，似乎有着一个谁也不知道的秘密。',
    content: '那天深夜，林婉儿被一阵奇怪的声音惊醒。\n\n她循着声音来到沈墨辰的书房，门虚掩着，里面透出昏黄的灯光。\n\n透过门缝，她看到了一幕让她震惊的画面——沈墨辰坐在书桌前，双手捂着脸，肩膀在微微颤抖。\n\n他在哭？\n\n那个冷酷无情的沈墨辰，竟然在深夜独自哭泣？\n\n书桌上摊着一本相册，相册里是一张泛黄的老照片。照片上，一个小男孩站在一对年轻夫妇中间，笑得灿烂无比。\n\n那是沈墨辰小时候的照片。\n\n"妈......对不起......"沈墨辰低哑的声音从书房中传出，像是一把钝刀割在林婉儿的心上。\n\n她悄悄退后，回到了自己的房间。躺在床上，她无法入睡。\n\n一直以来，她眼中的沈墨辰都是一个冷漠、危险、不可捉摸的男人。可在这一刻，她看到了他的另一面——一个藏着深深伤痛的人。\n\n第二天，她鼓起勇气找到了管家。\n\n"沈家......以前发生过什么事吗？"\n\n管家的脸上第一次出现了犹豫。沉默了很久，他才缓缓开口："大少爷的母亲......在他十岁那年去世了。不是意外。"\n\n"什么意思？"\n\n"是自杀。在少爷面前。"管家的声音低沉，"从那以后，少爷就变了。他不再相信任何人，也不再对任何人付出真心。他说，爱是这个世界上最危险的赌注。"\n\n林婉儿的心像是被什么东西狠狠地撞了一下。\n\n原来，那个把她当作赌注的男人，自己也是命运赌局中的一颗棋子。',
    wordCount: 4100,
    viewCount: 162000,
    publishDate: '2024-05-10',
    isNew: false,
    isHot: true,
  },
  {
    id: 'ch-35',
    title: '第三十五章：黑幕背后',
    slug: 'chapter-35',
    categoryId: 'cat-4',
    categoryName: '真相渐露',
    chapterNumber: 35,
    excerpt: '林婉儿偶然间发现了一封尘封多年的信。信中的内容彻底颠覆了她对这场赌局的所有认知——原来在沈墨辰的背后，还有一个更大的操纵者。',
    content: '林婉儿偶然间在图书馆的一本旧书中发现了一封泛黄的信件。\n\n信件的署名是"沈墨辰的母亲"。日期是二十年前。\n\n她的手颤抖着打开信纸，上面的文字娟秀而悲凉。\n\n"辰儿，当你读到这封信的时候，妈妈已经不在了。不要怪妈妈自私，妈妈只是太累了。你父亲是一个好企业家，却不是一个好丈夫。他用对待商业谈判的方式经营婚姻，用合同和条款衡量爱情。"\n\n"但是辰儿，妈妈希望你记住——真正的爱不是赌注，不是交易，不是征服。真正的爱是即使知道会受伤，也愿意打开心扉。不要像你父亲一样，把人生当成一盘棋局......"\n\n信的末尾，有一段被泪水模糊的文字。\n\n"妈妈最后悔的事，不是嫁给你父亲，而是在你们三兄弟之间种下了竞争的种子。那个荒唐的游戏——比谁能最快征服一个人的心——是妈妈在绝望中提出的。我只是想让你父亲看看，人心是不能被征服的。可是妈妈错了，妈妈大错特错。"\n\n林婉儿的手剧烈颤抖着。\n\n原来这场赌局，早在二十年前就已经开始了。它不是沈墨辰的发明，而是一个家族悲剧的延续。\n\n而沈墨辰——他看似是操纵者，实际上也是这个诅咒的囚徒。\n\n她拿着信，冲出图书馆，一路跑到沈墨辰的房间。\n\n"我要告诉你一件事。"她将信拍在他的桌上。\n\n沈墨辰低头看着信，脸色一点一点地变白。\n\n"你从哪里找到的？"\n\n"这不重要。重要的是——你知道这一切吗？你知道这个赌约的源头是什么吗？"\n\n沈墨辰沉默了很久。\n\n当他终于抬起头时，林婉儿在他的眼中第一次看到了脆弱。\n\n"我知道。"他的声音很轻，"我一直都知道。"',
    wordCount: 5000,
    viewCount: 189000,
    publishDate: '2024-06-20',
    isNew: false,
    isHot: true,
  },
  {
    id: 'ch-50',
    title: '第五十章：最后的抉择',
    slug: 'chapter-50',
    categoryId: 'cat-5',
    categoryName: '最终抉择',
    chapterNumber: 50,
    excerpt: '赌约的期限到了，林婉儿必须做出选择。是离开这个让她遍体鳞伤的地方，还是留在这个让她又爱又恨的男人身边？',
    content: '六个月。\n\n赌约的期限到了。\n\n林婉儿站在沈家别墅的大门前，手里拎着一个行李箱。身后是那座她生活了半年的金碧辉煌的牢笼，前方是未知的自由。\n\n沈墨辰站在门口，依旧是那副从容淡定的模样。但林婉儿知道，那只是他的面具。\n\n"你赢了。"沈墨辰说。\n\n"什么意思？"\n\n"赌约的规则是让我征服你。但是婉儿——"他顿了顿，"是你征服了我。"\n\n林婉儿的心脏漏跳了一拍。\n\n"我从一开始就在骗自己。"沈墨辰的声音低沉而沙哑，"我告诉自己，这只是一场游戏，你只是一个赌注。可是在每一个看着你入睡的夜晚，在每一次你对我微笑的瞬间，我都在沦陷。我发现我害怕的不是输掉赌约，而是失去你。"\n\n他从口袋里拿出那份赌约协议，当着林婉儿的面，将它撕成了碎片。\n\n纸片在空中飞舞，像蝴蝶一样落在两人之间。\n\n"不用选了。"他说，"赌约结束了。从现在开始，一切都由你来决定。留下来，或者离开——都是你的自由。"\n\n林婉儿看着那些纸片，又看着沈墨辰。\n\n她想起了这半年来的点点滴滴——新婚之夜她的恐惧，发现赌约时的愤怒，沦陷时的矛盾，以及那个深夜他独自哭泣的身影。\n\n她放下了行李箱。\n\n"我有一个条件。"\n\n"什么？"\n\n"从今往后，不许再有秘密。不许再有赌约。你的人生，我要全部参与。"\n\n沈墨辰愣了一下，随即笑了。那是林婉儿第一次看到他的笑容真正抵达眼底。\n\n"成交。"他伸出手。\n\n林婉儿握住他的手，感受到了从未有过的温暖。\n\n阳光穿过云层，洒在两人身上。远处的海浪拍打着礁石，像是为这个崭新的开始奏响的乐章。\n\n荒唐的赌约终于落幕，而真正的故事，才刚刚开始。',
    wordCount: 4800,
    viewCount: 210000,
    publishDate: '2024-08-01',
    isNew: true,
    isHot: true,
  },
  {
    id: 'ch-51',
    title: '第五十一章：新的开始',
    slug: 'chapter-51',
    categoryId: 'cat-5',
    categoryName: '最终抉择',
    chapterNumber: 51,
    excerpt: '赌约结束后的新生活开始了。但命运似乎并不打算就此放过他们——沈家的另一个秘密正在浮出水面。',
    content: '赌约结束后的第一个清晨，阳光格外明亮。\n\n林婉儿在沈墨辰的臂弯中醒来，这是半年来她第一次感到真正的安心。那些谎言、欺骗和游戏，终于成为了过去。\n\n"早安，沈太太。"沈墨辰的声音带着清晨特有的沙哑。\n\n"早安，沈先生。"林婉儿微笑。\n\n他们像任何一对普通的夫妻一样，一起吃早餐，一起看晨间新闻，一起讨论今天要做的事情。\n\n但这种平静并没有持续太久。\n\n上午十点，一辆黑色宾利停在了别墅门口。从车上走下来一个头发花白但精神矍铄的老人。\n\n沈墨辰看到来人，脸色瞬间变了。\n\n"父亲。"\n\n沈父走进客厅，目光扫过林婉儿，然后落在儿子身上。\n\n"听说赌约结束了？"\n\n"是的。"\n\n"你输了？"\n\n"我赢了。"沈墨辰握住林婉儿的手，"我赢回了自己的人生。"\n\n沈父沉默了片刻，突然放声大笑。那笑声在空旷的客厅中回荡，让人不寒而栗。\n\n"很好。"沈父收起笑容，"既然你觉得自己赢了，那就接受真正的考验吧。"\n\n他从口袋中拿出一个信封，扔在茶几上。\n\n"这是什么？"\n\n"你母亲去世前留下的第二个赌约。"沈父的眼神变得锐利，"她说过，如果你找到了真爱，就有资格知道真相。全部的真相。"\n\n沈墨辰的手微微颤抖着拿起信封。\n\n林婉儿看着他的侧脸，心中涌起一种强烈的不安。\n\n他们以为故事已经结束，却不知道真正的真相，才刚刚开始揭开面纱。',
    wordCount: 3500,
    viewCount: 98000,
    publishDate: '2024-08-03',
    isNew: true,
    isHot: false,
  },
  {
    id: 'ch-52',
    title: '第五十二章：第二份赌约',
    slug: 'chapter-52',
    categoryId: 'cat-5',
    categoryName: '最终抉择',
    chapterNumber: 52,
    excerpt: '信封中的内容让所有人都震惊了。二十年前，沈母留下的不是一个赌约，而是一个关于沈家商业帝国命运的秘密。',
    content: '沈墨辰拆开信封的动作很慢，仿佛手里拿着的是什么极其沉重的东西。\n\n信封里面只有一张泛黄的信纸和一把钥匙。\n\n信纸上只有寥寥数行字，笔迹与林婉儿在图书馆中发现的那封信如出一辙。\n\n"辰儿，如果你正在读这封信，说明你已经打破了妈妈的诅咒。妈妈为你感到骄傲。这把钥匙，可以打开瑞士银行的一个保险箱，保险箱编号在钥匙上。里面有沈氏集团真正的主人——不是你的父亲，而是你的舅舅。你父亲今天拥有的一切，都是从他手中夺来的。真相很残酷，但你必须要知道。爱你的妈妈。"\n\n客厅里安静得可怕。\n\n沈墨辰的手在发抖，他的脸色苍白得像一张纸。\n\n"这是真的吗？"他看向沈父。\n\n沈父的表情第一次出现了裂痕。一直以来维持的威严和冷静在瞬间崩塌了。\n\n"是真的。"他的声音沙哑，"你舅舅——是我的商业伙伴，也是我最信任的朋友。但为了得到公司，我背叛了他。你母亲知道你舅舅才是公司的创始人，却选择留在我身边。她一直在用自己的方式赎罪。"\n\n"所以她的自杀......"\n\n"不是因为恨我，而是因为她无法面对这个事实。那场赌约，她说是要证明人心不能被征服，其实......是在惩罚我。"\n\n林婉儿看着沈墨辰，他的眼眶红了。\n\n这个一直以来冷酷无情的男人，此刻像是一个被剥去所有盔甲的孩子。\n\n"我们去找那个保险箱。"林婉儿握住他的手，坚定地说。\n\n沈墨辰看着她，眼中的脆弱渐渐被坚定取代。\n\n"好。"\n\n无论真相是什么，他们都不再是一个人在面对。\n\n荒唐的赌约已经结束，关于真相的追寻，才刚开始。',
    wordCount: 3600,
    viewCount: 52000,
    publishDate: '2024-08-05',
    isNew: true,
    isHot: false,
  },
];